import api from "@/lib/axios";

import { Applicant } from "../types/applicants";

export enum ApplicantsKeys {
  GET_APPLICANTS = "get-applicants",
  GET_APPLICANT = "get-applicant",
  UPDATE_COHORT = "update-applicant-cohort",
  CONVERT_TO_FOUNDER = "convert-to-founder",
}

export interface ApplicantsResponse {
  data: Applicant[];
  total: number;
  skip: number;
  limit: number;
}

export const getApplicants = async (
  search?: string,
  sortBy?: string,
  sortOrder?: "asc" | "desc",
  skip?: number,
  limit?: number,
) => {
  const params: any = {};
  if (search) params.search = search;
  if (sortBy) params.sortBy = sortBy;
  if (sortOrder) params.sortOrder = sortOrder;
  if (skip !== undefined) params.skip = skip.toString();
  if (limit !== undefined) params.limit = limit.toString();

  const response = await api.get("/applicants", { params });

  if (response.data && "data" in response.data) {
    return {
      items: response.data.data as Applicant[],
      total: response.data.total,
      skip: response.data.skip,
      limit: response.data.limit,
    };
  }

  if (Array.isArray(response.data)) {
    return {
      items: response.data as Applicant[],
      total: response.data.length,
      skip: skip || 0,
      limit: limit || response.data.length,
    };
  }

  return {
    items: [],
    total: 0,
    skip: skip || 0,
    limit: limit || 10,
  };
};

export const getApplicant = async (id: string) => {
  const response = await api.get(`/applicants/${id}`);
  return response.data as Applicant;
};

export interface UpdateApplicantCohortDto {
  cohortId: string;
}

export const updateApplicantCohort = async (
  applicantId: string,
  cohortId: string,
) => {
  const response = await api.patch(`/applicants/${applicantId}/cohort`, {
    cohortId,
  });
  return response.data as Applicant;
};

export const convertToFounder = async (applicantId: string) => {
  const response = await api.post(
    `/applicants/${applicantId}/convert-to-licensee`,
  );
  return response.data;
};
